// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__fxcm2","load6":"styles_load6__VloTG","round":"styles_round__7bvMA"};